export const wallet = {
  wallet_deposits: "Deposits",
  // withdrawal_info_phone: "To ensure the money reaches the correct account, please make sure the number shown is your phone number.",
  // withdrawal_info_phone_2: "This is the number to which we will send the money you request.",
  // phone_number_registered: "Registered phone number:",
  // accounts: {
  //   selectBank: "Select bank",
  //   phoneNumber: "Phone number:",
  //   amount: "Amount:",
  //   account: "Account:",
  //   noAccounts: "You have not registered any accounts",
  //   addAccountPagoMovil: "Add Mobile Payment Account",
  // },
  // yourBalance: "Available balance:",
  // notBalanceAvailable: "No available balance",
  // balanceInsufficient: "Insufficient balance",
  // isAmountEmpty: "Enter an amount",
  // areYouSure: "Are you sure you want to withdraw",
  // entityBank: "Bank", // Simplified from "Banking Entity"
  // phoneNumber: "Phone number", // This is a duplicate from the previous section
  // amountWithdraw: "Amount to withdraw",
  // withdrawTitle: "Withdraw Money",
  // yourBalanceLeft: "Your remaining balance will be:",
  // movements: {
  //   deposits: "Deposits",
  //   transfers: "Transfers",
  //   withdrawals: "Withdrawals",
  //   plays: "Plays",
  // },
  // transactions: {
  //   sent: "Sent to",
  //   received: "Received from",
  //   rygBet: "Bets",
  //   rygWin: "Wins",
  //   rygRefund: "Refunds",
  //   withdrawals: "Withdrawals",
  //   deposits: "Deposits",

  // }
};

export default wallet;
